import UserActiveRetentionAfterFirstSessionChart from './UserActiveRetentionAfterFirstSessionChart';

export { UserActiveRetentionAfterFirstSessionChart };
